// Store request form. Pass outlookMode for stacked labels/buttons (Outlook taskpane).
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { Button, Col, FormGroup, Label, Row } from "reactstrap";
import { InputField, ReactSelect, ToggleField, required } from "modules/4_final_form/web";
import LineItemsFields from "./LineItemsFields";
import _ from "lodash";
import { getMWProducts } from "modules/moneyworks/products/actions";
import { getEmployees } from "modules/employees/actions";
import { getProjects } from "modules/projects/actions";

function mapStateToProps(state) {
  return {
    projects: state.projects,
    mw_products: state.mw_products,
    employees: state.employees,
  };
}

const StoreRequestForm = (props) => {
  const { handleSubmit, formLabel, cancelFunction, projects, mw_products, employees, linesLocked, values, form, outlookMode } = props;
  const toolAccount = !!values?.tool_account;

  useEffect(() => {
    if (_.isEmpty(projects)) {
      props.getProjects(true);
    }
    if (_.isEmpty(mw_products)) {
      props.getMWProducts();
    }
    if (_.isEmpty(employees)) {
      props.getEmployees();
    }
  }, []);

  const projectOptions = useMemo(
    () =>
      _.map(_.sortBy(projects, "number"), (p) => ({
        label: p.display_name,
        value: p.id,
      })),
    [projects],
  );

  const employeeOptions = useMemo(
    () =>
      _.map(_.sortBy(employees, ["last_name", "first_name"]), (emp) => ({
        value: emp.id,
        label: emp.display_name,
      })),
    [employees],
  );

  const productOptions = useMemo(
    () =>
      _.map(_.sortBy(mw_products, "code"), (p) => ({
        label: `${p.code} - ${p.description}`,
        value: `${p.code} - ${p.description}`,
        stockcode: p.code,
      })),
    [mw_products],
  );

  const fieldRow = (label, children, fieldMd = 6) =>
    outlookMode ? (
      <FormGroup>
        <Label>{label}</Label>
        {children}
      </FormGroup>
    ) : (
      <FormGroup row>
        <Label md={2}>{label}</Label>
        <Col md={fieldMd}>{children}</Col>
      </FormGroup>
    );

  return (
    <form>
      {fieldRow("Tool Account", <Field component={ToggleField} name="tool_account" disabled={linesLocked} />, 2)}
      <OnChange name="tool_account">
        {(value) => {
          if (value) {
            form.change("project_id", null);
          } else {
            form.change("tool_account_employee_id", null);
          }
        }}
      </OnChange>

      {!toolAccount &&
        fieldRow(
          "Project",
          <Field component={ReactSelect} name="project_id" validate={required} disabled={linesLocked} options={projectOptions} virtualList />,
        )}

      {toolAccount &&
        fieldRow(
          "Employee",
          <Field
            component={ReactSelect}
            name="tool_account_employee_id"
            validate={required}
            disabled={linesLocked}
            options={employeeOptions}
          />,
        )}

      {fieldRow("Notes", <Field component={InputField} name="notes" type="textarea" parse={(v) => v} disabled={linesLocked} />)}

      <hr />
      <LineItemsFields disabled={linesLocked} productOptions={productOptions} stacked={outlookMode} />

      <hr />
      {outlookMode ? (
        <div>
          {!linesLocked && (
            <Button color="success" onClick={handleSubmit} type="button" className="w-100" size="lg">
              {formLabel}
            </Button>
          )}
          {linesLocked && <small className="text-muted">Locked after a purchase order is created.</small>}
          <Button color="danger" onClick={cancelFunction} type="button" className="w-100 mt-2">
            Cancel
          </Button>
        </div>
      ) : (
        <Row>
          <Col>
            {!linesLocked && (
              <Button color="success" onClick={handleSubmit} type="button">
                {formLabel}
              </Button>
            )}
            {linesLocked && <small className="text-muted">Locked after a purchase order is created.</small>}
          </Col>
          <Col className="text-right">
            <Button color="danger" onClick={cancelFunction} type="button">
              Cancel
            </Button>
          </Col>
        </Row>
      )}
    </form>
  );
};

export default connect(mapStateToProps, { getProjects, getMWProducts, getEmployees })(StoreRequestForm);
